import { IApplicationState } from '../../types/redux';

export function getConstructionProgress(state: IApplicationState) {
  return state.newbuilding.constructionProgress;
}

export function getConstructionProgressUrl(state: IApplicationState) {
  const { fullUrl } = state.newbuilding;

  return fullUrl + 'hod-stroitelstva/';
}
